import { useMutation, useQueryClient } from "react-query";

import { subscriptionItemsKey } from "../../queries";
import { deleteSubscription } from "./deleteSubscription.fetcher";
import { DeleteSubscriptionMutationResult } from "./deleteSubscription.types";

export function useDeleteSubscriptionMutation(): DeleteSubscriptionMutationResult {
  const queryClient = useQueryClient();

  return useMutation(deleteSubscription, {
    onSettled: () => {
      queryClient.invalidateQueries(subscriptionItemsKey);
    },
  });
}
